import "./FilterCompExam.css";
// import { IoSearch } from "react-icons/io5";
// import { SiMicrosoftexcel } from "react-icons/si";

const FilterCollege = () => {
  return (
    <>
      <div className="college-all-course-inner-main-wrapper">
        <div className="headertable">
          <h5>Competitive Exam</h5>
          <table>
            <thead>
              <tr>
                <th>Exam Categeroris</th>
                <th>Subject</th>
                <th>Topic</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Gate</td>
                <td>English</td>
                <td>1</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Gate</td>
                <td>English</td>
                <td>1</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Gate</td>
                <td>English</td>
                <td>1</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Gate</td>
                <td>English</td>
                <td>1</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Gate</td>
                <td>English</td>
                <td>1</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Gate</td>
                <td>English</td>
                <td>1</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Gate</td>
                <td>English</td>
                <td>1</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Gate</td>
                <td>English</td>
                <td>1</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Gate</td>
                <td>English</td>
                <td>1</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
              <tr>
                <td>Gate</td>
                <td>English</td>
                <td>1</td>
                <td>
                  <i class="fa-solid fa-file-pen"></i>
                  <i class="fa-solid fa-trash-can"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default FilterCollege;
